import { ArrowLeft } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../api';
import { useAuth } from '../../auth-context';
import { t } from '../../i18n';
import type { ParentMessage } from '../../types';
import { AppShell } from '../shared/AppShell';
import { Card } from '../shared/Card';

export function MessagesArchive() {
  const navigate = useNavigate();
  const { state } = useAuth();
  const child = state.status === 'child' ? state.child : null;
  const [messages, setMessages] = useState<ParentMessage[] | null>(null);

  useEffect(() => {
    api.myMessages(false).then((res) => setMessages(res.messages));
  }, []);

  return (
    <AppShell ramp={child?.color_ramp}>
      <main className="mx-auto flex min-h-dvh max-w-md flex-col gap-5 p-5">
        <header className="flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            aria-label={t('common.back')}
            className="text-ink-muted"
          >
            <ArrowLeft size={22} />
          </button>
          <h1 className="text-[18px] font-medium">{t('messages.archive_title')}</h1>
        </header>

        {messages === null ? (
          <p className="text-center text-[13px] text-ink-muted">{t('common.loading')}</p>
        ) : messages.length === 0 ? (
          <p className="text-center text-[13px] text-ink-muted">{t('messages.archive_empty')}</p>
        ) : (
          <ul className="flex flex-col gap-3">
            {messages.map((m) => (
              <li key={m.id}>
                <Card>
                  <div className="text-[11px] uppercase tracking-wide text-ink-subtle">
                    {new Date(m.sent_at).toLocaleString('uz-UZ', {
                      timeZone: 'Asia/Tashkent',
                      day: '2-digit',
                      month: 'short',
                      hour: '2-digit',
                      minute: '2-digit',
                    })}
                  </div>
                  <div
                    className={[
                      'mt-1',
                      m.message_type === 'emoji' ? 'text-[40px]' : 'text-[15px]',
                    ].join(' ')}
                  >
                    {m.content}
                  </div>
                </Card>
              </li>
            ))}
          </ul>
        )}
      </main>
    </AppShell>
  );
}
